import { memo } from 'react';
import Logo from '../Logo';
import Typography from '../Typography';

import './RewardsBadge.scss';

const RewardsBadgeComponent = () => {
  return (
    <div className="nostra__rewardsBadge">
      <Logo type="token-STRK" size={12} />
      <Typography variant="button-xs" weight="bold" color="text-primary">
        Rewards
      </Typography>
    </div>
  );
};
export const RewardsBadge = memo(RewardsBadgeComponent);
